import * as React from 'react';
export var Loader = function (_a) {
    var loading = _a.loading, text = _a.text;
    return (React.createElement("div", { className: "shade " + (loading ? 'display' : '') },
        React.createElement("div", { className: "spinner" }),
        text && React.createElement("div", { className: "text" }, text)));
};
//# sourceMappingURL=Loader.js.map